import { DataBean } from "../DataBean";

export class OperationType extends DataBean {


    public async getOperationTypeCatalog(processType:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getOperationTypeCatalog_Number_String_Number_Number", [processType,regexStr,page,recordsPerPage]);
    }

  
    

 
}